import { createFileRoute } from '@tanstack/react-router';

import { ContactDetail } from '@/features/contacts/ContactDetail';

export const Route = createFileRoute('/_authenticated/contacts/$contactId')({
  component: function ContactDetailPage() {
    const { contactId } = Route.useParams();
    return <ContactDetail contactId={contactId} />;
  },
});
